// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  py, my, mx, px, ml
} from 'styled-components-spacing';
import { linkButtonAquaMarine, linkButtonAquaMarineInverted, HeroSectionGetStarted } from '@styles/links';
import Separator from '@components/Separator';

import { SearchIconDesktop } from '@images/svg/index';

export const StyledButtonSignInOut = styled.div`
  ${({ inverted }) => (inverted ? linkButtonAquaMarineInverted : linkButtonAquaMarine)}
  ${({ heroSection }) => (heroSection && HeroSectionGetStarted)}
  transition: all 0.5s ease;

  ${py(2.5)}
  cursor: pointer;

  ${breakpoint('desktop')`
    ${ml(3)}  
    ${px(3)}
    max-width: 120px;
  `}

  ${breakpoint('largeDesktop')`
    ${ml(4)}
    ${px(5)}
    max-width: none;
  `}
`;

export const StyledSeparator = styled(Separator)`
  ${my(1)}
  ${mx(3.5)}
`;

export const SearchIconImg = styled(SearchIconDesktop)`
  height: 100%;
  width: 100%;
  z-index: 2;
  & path {
    fill: '#505050';
  }
  ${({ heroSection }) => (heroSection && `
     fill: white;
     path{
     fill: white;
     }
    `)}
  // pointer: cursor;
  cursor: pointer;

`;

export const SearchImg = styled.div`
  height: 25px;
  // width: 25px;
`;
// 689FB8
